export enum CodeEspece {
    POMME = 'POMME',
    POIRE = 'POIRE'
}
